import React, { useContext, useEffect, useCallback } from 'react';
import { IonButton, IonFooter, IonProgressBar } from '@ionic/react';
import { PageContext } from '../../contexts/AppContexts';
// import { AppContext } from '../../global/AppContext';
import MatchmakingContext from '../../global/MatchmakingContext';
import { StartFightContext } from './StartFightContext';

/**
 * Footer for the start fight modal. Contains a progress bar and a next button.
 * @param {Object} props
 * @returns
 */
function ModalFooter() {
  const pageCtx = useContext(PageContext);
  const matchmakingCtx = useContext(MatchmakingContext);
  // const appCtx = useContext(AppContext);
  const startFightCtx = useContext(StartFightContext);
  // I think footerNav and matchModalRef can be removed entirely in a refactor
  // eslint-disable-next-line no-unused-vars
  const { footerNav, matchModalRef } = useContext(StartFightContext);
  const pageIndexForGetMatched = 1;
  const pageIndexForGetItems = 2;
  const pageIndexForSummary = 3;

  const isNextEnabled = useCallback(() => {
    if (startFightCtx.pageIndex === 0) {
      const hasGame = !!startFightCtx.game?.id;
      const hasOutcome = !!startFightCtx.outcome?.id;
      const hasOutcomeTeam = !!startFightCtx.outcome?.team_id;
      const isOutcomeValidForTeam =
        hasOutcomeTeam &&
        (startFightCtx.outcome.team_id === startFightCtx.game?.teams?.home?.id ||
          startFightCtx.outcome.team_id === startFightCtx.game?.teams?.away?.id);

      if (hasGame && hasOutcome && isOutcomeValidForTeam) {
        return true;
      }

      return false;
    }

    if (startFightCtx.isReferralLinkCopied) {
      return false;
    }

    if (startFightCtx.pageIndex === pageIndexForGetMatched) {
      return startFightCtx.isMatchedClicked || startFightCtx.challenger?.id;
    }

    /* Unsure if we should replace the id 64 check here */
    /* If we add this back, it needs to account for the payment page sometimes being the last page */
    // if (startFightCtx.pageIndex === startFightCtx.pageCount - 1 && appCtx.restaurant.id === 64) {
    //   return startFightCtx.canGo[startFightCtx.pageIndex]?.() && startFightCtx.isPaymentComplete;
    // }

    return startFightCtx.canGo[startFightCtx.pageIndex]?.();
  }, [
    startFightCtx.pageIndex,
    // startFightCtx.pageCount,
    startFightCtx.canGo,
    startFightCtx.game?.id,
    startFightCtx.game?.teams?.home?.id,
    startFightCtx.game?.teams?.away?.id,
    startFightCtx.outcome?.id,
    startFightCtx.outcome.team_id,
    startFightCtx.isMatchedClicked,
    startFightCtx.challenger?.id,
    // startFightCtx.isPaymentComplete,
    startFightCtx.isReferralLinkCopied,
    // appCtx.restaurant.id,
  ]);

  const isOnFinalPage = startFightCtx.isPaymentRequired
    ? startFightCtx.pageIndex === startFightCtx.pageCount - 1
    : startFightCtx.pageIndex === startFightCtx.pageCount - 2;
  const isReferralStep = isOnFinalPage && startFightCtx.isReferClicked;
  const showCopyButton = isReferralStep && startFightCtx.isReferFriendModalOpen && !startFightCtx.isReferralLinkCopied;
  const showDoneButton = isReferralStep && startFightCtx.isReferFriendModalOpen && startFightCtx.isReferralLinkCopied;

  let buttonName = 'Next';

  if (showCopyButton || showDoneButton) {
    buttonName = 'Share Referral Link';
  } else if (isOnFinalPage) {
    buttonName = 'Finalize';
  } else if (startFightCtx.pageIndex === pageIndexForSummary && startFightCtx.isPaymentRequired) {
    buttonName = 'Add Payment';
  } else if (startFightCtx.pageIndex === pageIndexForSummary && !startFightCtx.isPaymentRequired) {
    buttonName = 'Finalize';
  }

  const progressValue =
    pageIndexForSummary && !startFightCtx.isPaymentRequired
      ? startFightCtx.pageIndex / (startFightCtx.pageCount - 2)
      : startFightCtx.pageIndex / (startFightCtx.pageCount - 1);

  // For skipping challenger page
  useEffect(() => {
    if (
      startFightCtx.pageIndex === pageIndexForGetMatched &&
      startFightCtx.challenger?.id &&
      matchmakingCtx.state.challenger
    ) {
      if (isNextEnabled()) {
        pageCtx.modals.startFight.current.nextPage();
      }
    }
  }, [
    startFightCtx.pageIndex,
    startFightCtx.challenger,
    matchmakingCtx.state.challenger,
    pageCtx.modals.startFight,
    isNextEnabled,
  ]);

  // For skipping items page
  useEffect(() => {
    if (
      startFightCtx.pageIndex === pageIndexForGetItems &&
      startFightCtx.items.length > 0 &&
      matchmakingCtx.state.items?.length > 0 &&
      startFightCtx.items.length === matchmakingCtx.state.items?.length
    ) {
      if (isNextEnabled()) {
        pageCtx.modals.startFight.current.nextPage();
      }
    }
  }, [
    startFightCtx.pageIndex,
    pageCtx.modals.startFight,
    isNextEnabled,
    startFightCtx.items,
    matchmakingCtx.state.items,
  ]);

  return (
    <IonFooter className='ion-no-border' ref={footerNav}>
      <div className='ion-padding'>
        <IonButton
          expand='block'
          onClick={() => {
            if (showDoneButton) {
              pageCtx.modals.startFight.current.dismiss();
            } else if (showCopyButton) {
              startFightCtx.onShareLinkClicked();
            } else if (startFightCtx.pageIndex === pageIndexForSummary && !startFightCtx.isPaymentRequired) {
              pageCtx.modals.startFight.current.submit();
            } else {
              pageCtx.modals.startFight.current.nextPage();
            }
          }}
          disabled={
            !isNextEnabled() || startFightCtx.submitted
            //  || (showCopyButton && !startFightCtx.hasCopiedReferralLink)
          }>
          <p>{buttonName}</p>
        </IonButton>
      </div>
      <IonProgressBar value={progressValue} />
    </IonFooter>
  );
}

export default ModalFooter;
